const { isNull } = require('lodash');

module.exports = function(value) {
  return isNull(value) ? '' : value;
};
